// export type TDetailsPageType = 'Panel' | 'Gene'
export enum TDetailsPageType {
  Panel = 'panel',
  Gene = 'gene',
}
